import axios from 'axios';
import * as Constants from "../common/constants";
import { UserAdminModel } from "../models/user/userAdminModel";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { UserFilterSettingsModel } from "../models/user/userFilterSettingsModel";
import AuthService from './authService';

class UserService {
  authService = new AuthService();

  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  getAllUsers(from: number, numberOfRows: number, settings: UserFilterSettingsModel) {
    return axios({
      url: `adminUser/getAll/${from}/${numberOfRows}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(settings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getUser(id: number) {
    return axios({
      url: `adminUser/getById/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  addUser(user: UserAdminModel) {
    return axios({
      url: `adminUser/create`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(user)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editUser(id: number, user: UserAdminModel) {
    return axios({
      url: `adminUser/update/${id}`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(user)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  deleteUser(id: number) {
    return axios({
      url: `adminUser/delete/${id}`,
      method: 'delete'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default UserService;
